import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";

// interface
import { CallItem } from "../data/calls";

//images
import imagePlaceholder from "../assets/images/users/user-dummy-img.jpg";
import { viewMsgMemberAsync } from "../../src/api/chats";
import FadeAlert from "./FadeAlert";
import { Tab, Tabs } from "react-bootstrap";
import UserAvatar from "./UserAvatar";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";

interface ViewMessageReadStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  mId: string;
}

const ViewMessageReadStatusModal = ({ isOpen, onClose, mId }: ViewMessageReadStatusModalProps) => {

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (profile2) => ({
      isDev: profile2.isDev
    })
  );
  const { isDev } = useAppSelector(storeData);

  const [isloadig, setIsLoading] = useState<boolean>(true);
  const [errMsg, setErrMsg] = useState<string>("");
  const [users, setUsers] = useState([]);
  const [readCount, setReadCount] = useState(null);
  const [unreadCount, setUnreadCount] = useState(null);

  useEffect(() => {
    setReadCount(null);
    setUnreadCount(null);

    if (isOpen) {
      //console.log('view status of ' + mId);
      viewMsgMemberAsync(mId)
        .then(resp => {
          setUsers(resp);
          setIsLoading(false);
          setReadCount((resp ?? []).filter((item: any) => !item.isSender && item.isRead).length);
          setUnreadCount((resp ?? []).filter((item: any) => !item.isSender && !item.isRead).length);
        })
        .catch(err => {
          setErrMsg((err as Error).message);
          console.error(err);
          setIsLoading(false);
        });
    }
  }, []);

  const UserInfo = (key: number, item: any, isRead: boolean) => {
    return (item.isSender || item.isRead != isRead) ? null :
      <div key={key} className="d-flex align-items-center mb-1">

        <UserAvatar
          profileImage={item.profileImage}
          bgColor={item.bgColor}
          foreColor={item.foreColor}
          abbrName={item.abbrName}
        />
        <div className="flex-grow-1 overflow-hidden text-start">
          <p className="text-truncate mb-0">
            <span className={"badge badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserTypeBg(item.userType)}>{Utils.GetUserTypeText(item.userType)}</span>
            &nbsp;{item.fullName}

            {isDev && (
              <>
                <span className={"user-signalr-" + (item.signalR ? "yes" : "no")}>S</span>
                <span className={"user-signalr-" + (item.push ? "yes" : "no")}>P</span>
              </>
            )}
          </p>
        </div>
      </div>
  }
  const styles = {
    pnamelist: {
      "min-height": "180px",
      "max-height": "180px",
      "overflow": "auto",
      "padding": "2px"
    },
    modalBody: {
      border: "solid 1px gray",
      "border-radius": "7px",
      padding: "5px !important",
    }
  }


  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      tabIndex={-1}
      centered
      className="ViewMessageReadStatusModal"
      contentClassName="shadow-lg border-0"
      size="sm"
    >
      <ModalBody className="p-0">
        <div className="text-center p-4 pb-0">
          {errMsg && (<FadeAlert errorMessage={errMsg} />)}
          {isloadig && (<p>Loading...</p>)}


          <Tabs defaultActiveKey="tab1" id="controlled-tab-example">
            <Tab eventKey="tab1" title={"อ่านแล้ว (" + readCount + ")"}>
              <p className="p-1" style={styles.pnamelist}>
                {(users || []).map((item: any, key: number) => {
                  return UserInfo(key, item, true);
                })}
              </p>
            </Tab>
            <Tab eventKey="tab2" title={"ยังไม่อ่าน (" + unreadCount + ")"}>
              <p className="p-1" style={styles.pnamelist}>
                {(users || []).map((item: any, key: number) => {
                  return UserInfo(key, item, false);
                })}
              </p>
            </Tab>
          </Tabs>

        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewMessageReadStatusModal;
